import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

import { ErrorFormatter } from '../../../shared/formatter/error.formatter';
import { ArchiveLeadInput } from '../../../shared/models/lead/archiveLead.input';
import { FormsService } from '../../../shared/services/forms/forms.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-archived-modal',
  templateUrl: './archived-modal.component.html',
  styleUrls: []
})
export class ArchivedModalComponent implements OnInit, AfterViewInit {

  get f(): any {
    return this.form.controls;
  }

  sending = false;

  archiveLeadInput: ArchiveLeadInput = new ArchiveLeadInput();
  @ViewChild('content', { static: false }) content: Element;

  form: FormGroup;
  constructor(private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly spinner: NgxSpinnerService,
    private readonly toasterService: ToastService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly errorFormatter: ErrorFormatter,
    private readonly formsService: FormsService) { }

  ngOnInit(): void {
    this.form = this.formsService.initArchiveForm();
  }

  changeArchiveOption(event: any): void {
    this.setArchivedOptionValidators(this.form);
    this.formsService.changeArchiveOption(this.form, event);
  }

  ngAfterViewInit(): void {
    this.modalsHandler.archivedLeadModal.subscribe(leadsId => {
      this.resetForm();
      this.archiveLeadInput.leadsId = leadsId;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  archiveLead(): void {

    this.spinner.show();
    if (this.form.invalid) {
      this.spinner.hide();

      return;
    }

    this.bindForm();

    this.formsService.sendArchiveForm(this.archiveLeadInput).then(() => {
      this.sending = true;
      this.modalService.dismissAll();
      if (this.archiveLeadInput.leadsId.length === 1) {
        this.leadComuService.launchReloadMyLead(this.archiveLeadInput.leadsId[0]);
        this.leadComuService.launchReloadLeads();

      } else {
        this.leadComuService.launchReloadLeads();
      }

      this.resetForm();
      this.spinner.hide();

      this.toasterService
        .showToast(
          'success',
          'toast.title.lead_archived_success',
          'toasts.messages.lead_archived_success'
        );
      this.sending = false;
    }).catch(err => {
      this.spinner.hide();
      this.toasterService
        .showToast(
          'error',
          'Error',
          this.errorFormatter.formatErrors(err) || 'Error al archivar'
        );
      this.sending = false;
    });
  }

  bindForm(): void {
    this.archiveLeadInput.archivedOption = this.f.archivedOption.value;
    this.archiveLeadInput.comments = this.f.comments.value;
  }

  resetForm(): void {
    this.form.reset();
    this.f.comments.disable();
    this.archiveLeadInput.archivedOption = '';
    this.archiveLeadInput.comments = '';
  }

  setArchivedOptionValidators(form: FormGroup) {
    const formControls = form.controls;
    const archivedOption = this.f.archivedOption.value;

    if (archivedOption === 'other') {
      formControls.comments.setValidators([Validators.required]);
    } else {
      formControls.comments.setValidators(null);
    }
  }
}
